module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M9.143 9.143h3.428L8 2.286 3.429 9.143h3.428v3.428h2.286V9.143zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/top3-transparent.svg
// module id = 889
// module chunks = 0